import React from "react"
import { graphql } from "gatsby"
import StructuredText from "../custom-structured-text-renderer"
import FormComponent from "../../form"
import { NewsletterArrow } from "../../icons"
import parse from "html-react-parser"
import { Asset } from '../../../../plugins/gatsby-plugin-atollon'

const Newsletter = ({ title, image, richContent, description, form, onSubmitSuccess }) => {

  const formSchema = Array.isArray(form) ? form[0] : form

  return (
    <section className="newsletter">
      <div className="newsletter__inner">
        <div className="newsletter__content">
          {title && <h2>{parse(title)}</h2>}
          {richContent && <StructuredText data={richContent} />}
          {description && <p>{parse(description)}</p>}
          {formSchema && <FormComponent form={formSchema} submitIcon={<NewsletterArrow />} onSubmitSuccess={onSubmitSuccess} />}

        </div>

        <div className="newsletter__image">
          {image && (typeof image === "string"
            ? <div className="img-wrap"><img loading="lazy" src={image} alt="Newsletter" /></div>
            : <Asset className="landing-banner__bg" asset={image} />)}
        </div>
      </div>
    </section>
  )
}

export default Newsletter

export const query = graphql`
  fragment NewsletterProps on DatoCmsNewsletter {
    ... on DatoCmsNewsletter {
      id
      title
      image {
        ...InternalAssetProps
      }
      richContent {
        value
      }
      form {
      ...FormProps
    }
    }
  }
`
